'use strict';
module.exports = function sanitiseMapTitle (mapTitle) {
	if (!mapTitle) {
		return false;
	}
	return mapTitle.replace(/[~#%&*{}+/\\:;<>?|'".]/g, '');
};

